// Hardcoded founder allowlist. This is the CLIENT-SIDE layer only and is
// used to decide whether to render the "Admin" sidebar link and route.
//
// The real access control is server-side in mme-tagging-service via the
// MME_FOUNDER_EMAILS env var (see internal/http/middleware/jwt.go).
// Never rely on this file alone to protect sensitive data.
export const FOUNDER_EMAILS = [
  'gokuljinusclmda@gmail.com',
  'gokul@railtech.io',
];

export const isFounder = (email) => {
  if (!email) return false;
  const lower = String(email).toLowerCase().trim();
  return FOUNDER_EMAILS.some((f) => f.toLowerCase() === lower);
};
